'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkConditionWithReasons = checkConditionWithReasons;
exports.checkCondition = checkCondition;

var _OrderItem = require('./OrderItem.js');

var _OrderItem2 = _interopRequireDefault(_OrderItem);

var _availability = require('availability');

var availability = _interopRequireWildcard(_availability);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONDITIONS = {
    'true': function _true() {
        return { value: true, reasons: [] };
    },
    'false': function _false() {
        return { value: false, reasons: [{ reason: 'false' }] };
    },
    'not': function not(params) {
        var condition = params.condition;
        var ret = {
            value: !checkRecur(_lodash2.default.extend(params, { condition: condition.condition })).value,
            reasons: []
        };

        return ret;
    },
    'and': function and(params) {
        var condition = params.condition;

        var results = _lodash2.default.map(condition.conditions, function (_condition) {
            return checkRecur(_lodash2.default.extend(params, { condition: _condition }));
        });

        var value = _lodash2.default.every(results, function (r) {
            return r.value;
        });

        if (value) {
            return {
                value: value,
                reasons: []
            };
        }

        return {
            value: value,
            reasons: joinReasons(results)
        };
    },
    'or': function or(params) {
        var condition = params.condition;

        var results = _lodash2.default.map(condition.conditions, function (_condition) {
            return checkRecur(_lodash2.default.extend(params, { condition: _condition }));
        });

        var value = _lodash2.default.some(results, function (r) {
            return r.value;
        });
        if (value) {
            return {
                value: value,
                reasons: []
            };
        }

        return {
            value: value,
            reasons: joinReasons(results)
        };
    },
    'order_delivery_time': function order_delivery_time(params) {
        var condition = params.condition;
        var deliveryTime = params.deliveryTime;

        if (!deliveryTime) {
            return {
                value: true,
                reasons: []
            };
        }

        var util = new availability.AvailabilityIterator({ cal: deliveryTime, availability: condition.availability || {} });
        if (!util.hasNext()) {
            return false;
        }

        var status = util.next();

        return {
            value: !(status.status === 'unavailable'),
            reasons: [{
                reason: status.reason || 'order_delivery_time',
                availability: condition.availability,
                actual: deliveryTime
            }]
        };
    },
    'order_delivery_type': function order_delivery_type(params) {
        var condition = params.condition;
        var deliveryType = params.deliveryType;

        return {
            value: condition.deliveryType === deliveryType,
            reasons: [{
                reason: 'order_delivery_type',
                deliveryType: condition.deliveryType,
                actual: deliveryType
            }]
        };
    },
    'order_items_price': function order_items_price(params) {
        var condition = params.condition;
        var orderItems = params.orderItems;

        var totalApplicableItems = 0;
        _lodash2.default.each(orderItems, function (orderItem) {
            totalApplicableItems += _OrderItem2.default.getTotalPrice({ orderItem: orderItem });
        });

        if (condition.min && totalApplicableItems < condition.min) return {
            value: false,
            reasons: [{
                reason: 'order_items_price_min',
                min: condition.min,
                actual: totalApplicableItems
            }]
        };

        if (condition.max && totalApplicableItems > condition.max) return {
            value: false,
            reasons: [{
                reason: 'order_items_price_max',
                max: condition.max,
                actual: totalApplicableItems
            }]
        };

        return { value: true, reasons: [] };
    },
    'order_platform': function order_platform(params) {
        var condition = params.condition;
        var platform = params.platform;

        var ret = {
            value: platform === condition.platform,
            reasons: [{
                reason: 'order_platform',
                platform: condition.platform,
                actual: platform
            }]
        };

        return ret;
    },
    'order_source': function order_source(params) {
        var condition = params.condition;
        var source = params.source;

        return {
            value: source === condition.source,
            reasons: [{
                reason: 'order_source',
                source: condition.source,
                actual: source
            }]
        };
    },
    'user_charge_usage': function user_charge_usage() {
        throw new Error('user_charge_usage not implemented yet.');
    },
    'order_coupon': function order_coupon(params) {
        var condition = params.condition;
        var couponHashCode = params.couponHashCode;

        return {
            value: couponHashCode === condition.couponHashCode,
            reasons: [{
                reason: 'order_coupon',
                couponHashCode: condition.couponHashCode,
                actual: couponHashCode
            }]
        };
    }
};

function joinReasons(results) {
    return _lodash2.default.flatten(_lodash2.default.map(_lodash2.default.filter(results, function (r) {
        return !r.value;
    }), function (r) {
        return r.reasons;
    }));
}

function checkRecur(params) {
    var condition = params.condition;
    var func = CONDITIONS[condition.type] || function () {
        return { value: false, reasons: [] };
    };
    return func(params);
}

function checkConditionWithReasons(params) {
    var result = checkRecur(params);
    result.elaborateReasons = result.reasons;
    result.reasons = _lodash2.default.map(result.elaborateReasons, 'reason');
    return result;
}

function checkCondition(params) {
    return checkConditionWithReasons(params).value;
}

exports.default = {
    checkCondition: checkCondition,
    checkConditionWithReasons: checkConditionWithReasons
};